import axios from 'axios'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    workClientProjectsWorkTypeDefault: [
      // {
      //   project_id: null,
      //   work_type_category: { id: null },
      //   work_type: { id: null },
      //   is_hourly: null,
      //   hours: null,
      //   size: null,
      //   price: null,
      // },
    ],
    workClientProjectsWorkTypeGrid: [],
    workClientProjectsWorkTypeAll_project: [],
    workClientProjectsWorkTypeAll_project_old: [],
    workClientProjectsWorkTypeShow: null,
    pageData: null,
  },
  mutations: {
    setWorkClientProjectsWorkTypeDefault(state, payload) {
      state.workClientProjectsWorkTypeDefault = payload
    },
    setWorkClientProjectsWorkTypeDefaultPush(state) {
      state.workClientProjectsWorkTypeDefault.push({
        project_id: null,
        work_type_category: { id: null },
        work_type: { id: null },
        is_hourly: null,
        hours: null,
        size: null,
        price: null,
      })
    },
    setWorkClientProjectsWorkTypeDefaultDelete(state, id) {
      state.workClientProjectsWorkTypeDefault.splice(id, 1)
    },
    setWorkClientProjectsWorkTypeGrid(state, payload) {
      state.workClientProjectsWorkTypeGrid = payload
    },
    setWorkClientProjectsWorkTypeAll_project(state, payload) {
      state.workClientProjectsWorkTypeAll_project = payload
      state.workClientProjectsWorkTypeAll_project_old = payload
    },
    setWorkClientProjectsWorkTypeShow(state, payload) {
      state.workClientProjectsWorkTypeShow = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
    setDefaultProjectsWorkType(state) {
      state.workClientProjectsWorkTypeGrid = []
      state.workClientProjectsWorkTypeAll_project = []
    },
  },
  getters: {
    workClientProjectsWorkTypeDefault: (state) => {
      return state.workClientProjectsWorkTypeDefault
    },
    workClientProjectsWorkTypeGrid: (state) => {
      return state.workClientProjectsWorkTypeGrid
    },
    workClientProjectsWorkTypeAll_project: (state) => {
      if (state.workClientProjectsWorkTypeAll_project.length) {
        let list = state.workClientProjectsWorkTypeAll_project
        let list2 = []
        for (let i = 0; i < list.length; ++i) {
          if (list[i].work_type_category == null) {
            list[i].work_type_category = { id: null }
          }
          list2.push(list[i])
        }
        return list2
      } else {
        return state.workClientProjectsWorkTypeAll_project
      }
    },
    workClientProjectsWorkTypeAll_project_old: (state) => {
      return state.workClientProjectsWorkTypeAll_project_old
    },
    workClientProjectsWorkTypeShow: (state) => {
      return state.workClientProjectsWorkTypeShow
    },
    pageData: (state) => {
      return state.pageData
    },
  },
  actions: {
    onWorkClientProjectsWorkTypeGrid({ commit, rootState }, { limit, page }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/work/client/project/work-type/grid?limit=' +
            limit +
            '&page=' +
            page,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientProjectsWorkTypeGrid', resp.data.data)
            commit('setPageData', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectsWorkTypeAll_project({ commit, rootState }, project_id) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/work/client/project/work-type/grid?limit=0&filter[]=project_id:' +
            project_id,
          method: 'GET',
        })
          .then(async (resp) => {
            await commit(
              'setWorkClientProjectsWorkTypeAll_project',
              resp.data.data,
            )
            if (resp.data.data.length > 0) {
              await commit('setWorkClientProjectsWorkTypeDefault', [])
            }
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectsWorkTypeShow({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project/work-type/' + id,
          id: id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientProjectsWorkTypeShow', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectsWorkTypeCreate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project/work-type',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
            return resp.data
          })
          .catch((err) => {
            reject(err)
            return err
          })
      })
    },
    onWorkClientProjectsWorkTypeUpdate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project/work-type',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
            return resp.data
          })
          .catch((err) => {
            reject(err)
            return err
          })
      })
    },
    onWorkClientProjectsWorkTypeDelete({ rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project/work-type/' + id,
          id: id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
            return resp
          })
          .catch((err) => {
            reject(err)
            return err
          })
      })
    },
    onWorkClientProjectsWorkTypeDefaultAdd({ commit, state }) {
      commit('setWorkClientProjectsWorkTypeDefaultPush')
      return state.workClientProjectsWorkTypeDefault.length - 1
    },
    onWorkClientProjectsWorkTypeDefaultDelete({ commit }, id) {
      commit('setWorkClientProjectsWorkTypeDefaultDelete', id)
    },
  },
}
